export const dealsEn = {
  stages: {
    nouveau_lead: "New lead",
    qualifie: "Qualified",
    proposition_envoyee: "Proposal sent",
    negociation: "Negotiation",
    gagne: "Won",
    perdu: "Lost",
  },
  categories: {
    gala_receptionniste: "Gala Receptionist",
    gala_administration: "Gala Administration",
    site_web: "Website",
    automatisation: "Automation",
    autre: "Other",
  },
  loss_reasons: {
    prix: "Price",
    deja_fournisseur: "Already has a provider",
    pas_le_bon_moment: "Bad timing",
    pas_de_reponse: "No answer / ghosted",
    pas_le_decideur: "Not the decision maker",
    produit_ne_convient_pas: "Product not a fit",
    autre: "Other",
  },
  sources: {
    cold_call: "Cold call",
    organic: "Organic",
    gala: "Gala",
    referral: "Referral",
    other: "Other",
  },
  board: {
    totals_label: "Pipeline totals",
    // owner ruling: with a package the value is the MRR; a manual amount is annual (ARR, MRR = amount / 12)
    mrr_pipeline: "Pipeline MRR",
    mrr_weighted: "Weighted MRR",
    arr_pipeline: "Pipeline ARR",
    mrr_won_this_month: "MRR won this month",
    mrr_active: "Active MRR (clients)",
    arr_active: "%{arr} /yr · %{count} subscription(s)",
    mrr_arr: "%{mrr} /mo · %{arr} /yr",
    days_in_stage:
      "%{smart_count} day in stage |||| %{smart_count} days in stage",
    demo_chip: "Demo %{date}",
    lost_title: "Why was this deal lost?",
    choose_reason: "Choose a reason",
    mark_lost: "Mark as lost",
    won_title: "Congrats! Confirm the sale",
    final_amount: "Final amount (CAD)",
    confirm_won: "Confirm the sale",
    cancel: "Cancel",
    close_month: "Expected close (month)",
    only_mine: "My deals",
  },
  fields: {
    source: "Source",
    loss_reason: "Loss reason",
    loss_reason_detail: "Specify the reason",
    demo_at: "Demo date",
    teams_join_url: "Teams link",
    responsable: "Closer",
    setter: "Setter",
    account_manager: "Account manager",
    referrer: "Referrer",
  },
  owner: {
    roles_locked: "Only an admin can change the roles.",
    role_admin_only: "Only an admin can change the roles.",
    invalid_responsable:
      "This closer is not an active user. Choose an active user.",
    invalid_role_holder:
      "This role must go to an active user. Choose an active user.",
    no_longer_visible:
      "You can no longer see this opportunity: an admin changed its roles.",
  },
  // GAVION deal package (76_): the proposed package (its value = the MRR per month)
  proposal: {
    title: "Proposed package",
    package: "Proposed package",
    manual: "Manual amount (no package)",
    manual_hint: "For a manual amount, clear the package (×).",
    billing: "Billing",
    billings: { monthly: "Monthly", annual: "Annual" },
    annual_discount: "Annual (−%{pct} %)",
    addons: "Add-ons",
    qty: "Quantity",
    value: "Value (MRR)",
    per_month: "/mo",
    computed: "Computed from the proposed package: %{amount} /mo.",
    snapshot_note:
      "Prices are locked when saved: a catalog change does not change this opportunity.",
    invalid: "Invalid add-on choice for this package.",
    reprice: "Update to current price",
    reprice_hint: "Catalog prices changed since it was saved.",
    repriced: "Value updated: %{amount} /mo.",
    errors: {
      invalid_package:
        "This package is no longer offered. Choose an active package.",
      invalid_addons:
        "An add-on is not offered for this package, or its quantity is invalid.",
      invalid_billing: "Choose monthly or annual billing.",
      forbidden:
        "Only the Closer, the Account manager and admins change the proposed package.",
      no_proposal: "This opportunity has no proposed package.",
      deal_closed: "A won or lost opportunity keeps its value.",
    },
  },
  // GAVION deal amount visibility (72_): a Setter / Apporteur only never sees the amount
  amount: {
    hidden: "Value hidden",
    hidden_note: "Some values are hidden",
  },
  // GAVION deal-inline: « Create deal » — a contact created in the deal's company, association with the company
  create_inline: {
    new_contact: "New contact",
    company_first: "Choose the company first to create a contact.",
    form_title: "New contact at %{company}",
    fields: {
      first_name: "First name",
      last_name: "Last name",
      email: "Email",
      phone: "Phone",
      title: "Title",
    },
    create: "Create contact",
    creating: "Creating…",
    cancel: "Cancel",
    required: "First and last name are required.",
    invalid_email: "Invalid email.",
    created: "Contact created and added to the deal.",
    error:
      "The contact could not be created. Check your connection and try again.",
    duplicate: {
      email: "A contact already has this email: %{name}.",
      phone: "A contact already has this phone: %{name}.",
      name: "%{name} already exists at this company.",
      use: "Add this contact",
      create_anyway: "Create anyway",
    },
    link: {
      associate: "Associate this contact with %{company}",
      no_company: "This contact has no company.",
      other_company: "This contact is at %{company}: tick to move him.",
      done: "%{smart_count} contact associated with the company |||| %{smart_count} contacts associated with the company",
      error:
        "The deal is created, but associating the contacts with the company failed.",
    },
  },
  errors: {
    move_failed: "The move failed. The deal went back to its stage.",
    amount: "Enter a whole-dollar amount.",
    teams_url: "Paste an https://teams.microsoft.com/… link",
  },
};
